import { render } from "./InspectStatic.vue?vue&type=template&id=6d0a5d98"
import script from "./InspectStatic.vue?vue&type=script&lang=js"
export * from "./InspectStatic.vue?vue&type=script&lang=js"

import "./InspectStatic.vue?vue&type=style&index=0&id=6d0a5d98&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__